import { cn } from "@/lib/utils";

/** Frosted play glyph. Brightens when an ancestor with the `group` class is hovered. */
export function PlayButton({ className }: { className?: string }) {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(
        "transition-[opacity,fill-opacity,stroke-opacity] duration-200 ease-out motion-reduce:transition-none",
        className
      )}
      aria-hidden
    >
      <path
        d="M0 19.2C0 12.4794 0 9.11905 1.30792 6.55211C2.4584 4.29417 4.29417 2.4584 6.55211 1.30792C9.11905 0 12.4794 0 19.2 0H20.8C27.5206 0 30.8809 0 33.4479 1.30792C35.7058 2.4584 37.5416 4.29417 38.6921 6.55211C40 9.11905 40 12.4794 40 19.2V20.8C40 27.5206 40 30.8809 38.6921 33.4479C37.5416 35.7058 35.7058 37.5416 33.4479 38.6921C30.8809 40 27.5206 40 20.8 40H19.2C12.4794 40 9.11905 40 6.55211 38.6921C4.29417 37.5416 2.4584 35.7058 1.30792 33.4479C0 30.8809 0 27.5206 0 20.8V19.2Z"
        fill="white"
        className="[fill-opacity:0.2] group-hover:[fill-opacity:0.5]"
      />
      <path
        d="M19.2002 0.5H20.7998C24.1683 0.5 26.6647 0.500686 28.6406 0.662109C30.6107 0.823073 32.0195 1.14185 33.2207 1.75391C35.3845 2.85644 37.1436 4.61547 38.2461 6.7793C38.8582 7.98053 39.1769 9.38927 39.3379 11.3594C39.4993 13.3353 39.5 15.8317 39.5 19.2002V20.7998C39.5 24.1683 39.4993 26.6647 39.3379 28.6406C39.1769 30.6107 38.8582 32.0195 38.2461 33.2207C37.1436 35.3845 35.3845 37.1436 33.2207 38.2461C32.0195 38.8582 30.6107 39.1769 28.6406 39.3379C26.6647 39.4993 24.1683 39.5 20.7998 39.5H19.2002C15.8317 39.5 13.3353 39.4993 11.3594 39.3379C9.38927 39.1769 7.98053 38.8582 6.7793 38.2461C4.61547 37.1436 2.85644 35.3845 1.75391 33.2207C1.14185 32.0195 0.823073 30.6107 0.662109 28.6406C0.500686 26.6647 0.5 24.1683 0.5 20.7998V19.2002C0.5 15.8317 0.500686 13.3353 0.662109 11.3594C0.823073 9.38927 1.14185 7.98053 1.75391 6.7793C2.85644 4.61547 4.61547 2.85644 6.7793 1.75391C7.98053 1.14185 9.38927 0.823073 11.3594 0.662109C13.3353 0.500686 15.8317 0.5 19.2002 0.5Z"
        stroke="white"
        className="[stroke-opacity:0.2] group-hover:[stroke-opacity:0.5]"
      />
      <path
        d="M25.3748 18.433C26.2084 18.9072 26.2084 20.0928 25.3748 20.567L17.8757 24.8331C17.042 25.3073 16 24.7145 16 23.7661L16 15.2339C16 14.2855 17.042 13.6927 17.8757 14.1669L25.3748 18.433Z"
        fill="white"
      />
    </svg>
  );
}
